/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservationMaxReservationsPerSlot200Response
 */
export interface GetReservationMaxReservationsPerSlot200Response {
    /**
     * 
     * @type {number}
     * @memberof GetReservationMaxReservationsPerSlot200Response
     */
    maxReservationsPerSlot: number | null;
}

/**
 * Check if a given object implements the GetReservationMaxReservationsPerSlot200Response interface.
 */
export function instanceOfGetReservationMaxReservationsPerSlot200Response(value: object): value is GetReservationMaxReservationsPerSlot200Response {
    if (!('maxReservationsPerSlot' in value) || value['maxReservationsPerSlot'] === undefined) return false;
    return true;
}

export function GetReservationMaxReservationsPerSlot200ResponseFromJSON(json: any): GetReservationMaxReservationsPerSlot200Response {
    return GetReservationMaxReservationsPerSlot200ResponseFromJSONTyped(json, false);
}

export function GetReservationMaxReservationsPerSlot200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationMaxReservationsPerSlot200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'maxReservationsPerSlot': json['maxReservationsPerSlot'],
    };
}

export function GetReservationMaxReservationsPerSlot200ResponseToJSON(json: any): GetReservationMaxReservationsPerSlot200Response {
    return GetReservationMaxReservationsPerSlot200ResponseToJSONTyped(json, false);
}

export function GetReservationMaxReservationsPerSlot200ResponseToJSONTyped(value?: GetReservationMaxReservationsPerSlot200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maxReservationsPerSlot': value['maxReservationsPerSlot'],
    };
}

